import React, { useState } from "react";
import { Checkbox } from "antd";
import {
  getFoodCategoryAPi,
  postCategoryFoodApi,
} from "../../Api/BarestSupplierServices";
import { useEffect } from "react";
import { errorToast, succToast } from "../../Utils/Toast/Toast";
import Style from "./ChooseFoodCategory.module.css";
import MenuTitle from "../../Components/MenuTitlle/MenuTitle";
const ChooseFoodCategory = () => {
  const [category, setCategory] = useState();
  const [checked, setChecked] = useState([]);
  useEffect(() => {
    getFoodCategory();
  }, []);
  const handleChange = (checkedValues) => {
    setChecked(checkedValues);
  };
  const sendCategory = () => {
    let info = {
      category: checked,
    };
    postCategoryFoodApi(info, (res) => {
      if (res.status === 1) {
        succToast("با موفقیت اضافه شد");
      } else {
        errorToast(res.message);
      }
    });
  };
  /////get food category///////////////
  let categoryArray = [];
  let checkedArray = [];
  const getFoodCategory = async () => {
    const result = await getFoodCategoryAPi();
    setCategory(result.category);
  };
  category &&
    category.forEach((val) => {
      categoryArray.push({
        label: val.name,
        value: val.id,
      });
      if (val.checked === "1") {
        checkedArray.push(
          val.id,
        );
      }
    });
  return (
    <div>
      <MenuTitle title={"تعیین دسته بندی"}/>
      <div className={Style.picHolder}>
        <img src={"Assets/Images/foodCategory/categoryFood.svg"} alt=""/>
      </div>
      <div className={Style.foodCategoryHolder}>
        <p>حوزه ی فعالیت رستورانتان را انتخاب کنید</p>
        {category && (
          <Checkbox.Group
          className={Style.foodCategory}
            options={categoryArray}
            defaultValue={
              checkedArray.length === 0 ? null : checkedArray
            }
            onChange={handleChange}
          />
          )}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button className={Style.sendBtn} onClick={sendCategory}>
            ارسال
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChooseFoodCategory;
